module.exports = "/static-assets/_next/static/images/img-b5b7214476-55458df9ea34ee0d87976d1073f8a50e.webp";